import { Divider, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Table, Tbody, Td, Text, Tr, VStack } from "@chakra-ui/react";
import { colors } from "../../styles";

interface PrivacyModalProps {
    isOpen: boolean;    
    onClose: () => void;
}

export default function PrivacyModal(props: PrivacyModalProps) {
    return (
        <Modal size="2xl" motionPreset="slideInBottom" scrollBehavior="inside" isOpen={props.isOpen} onClose={props.onClose}>
            <ModalOverlay />
            <ModalContent maxH="90vh">
                <ModalHeader>
                    <Text fontSize={20} fontWeight={700} color={colors.black}>개인정보 수집 및 이용방침</Text>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody padding={10}>

                    {/* 레이블 */}

                    <Text fontSize={16} fontWeight={700} color={colors.black}>
                        팜챗(PharmChat) 개인정보 수집 및 이용방침
                    </Text>

                    {/* 구분선 */}

                    <Divider marginY={5} />

                    {/* 내용 */}

                    <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                        주식회사 더리얼(이하 “회사”)은 이용자의 개인정보를 보호하고 관련 법령을 준수하기 위하여<br />
                        다음과 같이 개인정보 처리방침을 수립하여 공개합니다.    
                    </Text>

                    {/* 개인정보 수집 및 이용 동의 내용 */}

                    <VStack
                        justifyContent={"flex-start"}
                        alignItems={"flex-start"}
                        width={"100%"}

                        marginTop={10}
                        spacing={10}
                    >

                        {/* 제 1조 [개인정보의 처리목적] */}

                        <VStack
                            justifyContent={"flex-start"}
                            alignItems={"flex-start"}
                            width={"100%"}
                        >

                            {/* 레이블 */}

                            <Text fontSize={16} fontWeight={700} color={colors.black}>
                                제 1조 [개인정보의 처리목적]
                            </Text>

                            {/* 내용 */}

                            <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                                회사는 다음의 목적을 위해 개인정보를 처리합니다.
                            </Text>

                            <Table width="100%" fontSize={14} variant="simple">
                                <Tbody>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            회원 관리
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            가입 의사 확인, 자격(약사·학생) 증빙 검토 및 승인, 본인 식별, 부정이용 방지.
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            서비스 제공
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            의약품 검색·분류 기능 제공 및 이용 패턴 분석을 통한 서비스 고도화.
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            마케팅
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            맞춤형 광고(피드 광고 등) 게재 및 신규 혜택 안내.                                    </Td>
                                    </Tr>
                                </Tbody>
                            </Table>
                        </VStack>

                        {/* 제 2조 [처리하는 개인정보의 항목] */}

                        <VStack
                            justifyContent={"flex-start"}
                            alignItems={"flex-start"}
                            width={"100%"}
                        >

                            {/* 레이블 */}

                            <Text fontSize={16} fontWeight={700} color={colors.black}>
                                제 2조 [처리하는 개인정보의 항목]
                            </Text>

                            {/* 내용 */}

                            <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                                회사는 가입 유형별로 필요한 최소한의 정보를 수집합니다.
                            </Text>

                            <Table width="100%" fontSize={14} variant="simple">
                                <Tbody>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            개국 약사
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            성명, 휴대폰번호, 면허번호, 이메일, 비밀번호, 약국정보(명칭·주소·요양기관번호), [증빙] 면허증·개설등록증·사업자등록증 이미지.
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            약사
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            성명, 휴대폰번호, 면허번호, 이메일, 비밀번호, 근무지 정보(약국·회사·병원·공직·기타), [증빙] 면허증 이미지.
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            약대생
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            성명, 휴대폰번호, 이메일, 비밀번호, 소속 대학, [증빙] 재학증명서 이미지.                              
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            커뮤니티 이용 시 수집 항목
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            회원이 작성한 게시물(텍스트, 이미지), 댓글, 답글, 스크랩(저장) 내역, 프로필 설정 정보.                               
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            자동 수집
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            IP주소, 쿠키, 서비스 이용 기록(검색어·선택 필터·클릭 로그), 기기 정보.                          
                                        </Td>
                                    </Tr>
                                </Tbody>
                            </Table>
                        </VStack>

                        {/* 제 3조 [개인정보의 제3자 제공 및 위탁] */}

                        <VStack
                            justifyContent={"flex-start"}
                            alignItems={"flex-start"}
                            width={"100%"}
                        >

                            {/* 레이블 */}

                            <Text fontSize={16} fontWeight={700} color={colors.black}>
                                제 3조 [개인정보의 제3자 제공 및 위탁]
                            </Text>

                            {/* 내용 */}

                            <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                                ① 회사는 원칙적으로 이용자의 동의 없이 개인정보를 외부에 제공하지 않습니다.<br />
                                다만, 법령에 특별한 규정이 있는 경우나 수사 목적으로 법령에 정해진 절차에 따른 요구가 있는 경우에는<br />
                                예외로 합니다.<br /><br />
                                ② 회사는 서비스 품질 향상 및 제휴 서비스 제공을 위해 아래와 같이 개인정보 처리를 위탁하거나,<br />
                                이용자의 별도 동의를 얻어 제3자에게 제공할 수 있습니다.
                            </Text>

                            <Table width="100%" fontSize={14} variant="simple">
                                <Tbody>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            업무 위탁
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            시스템 운영(클라우드), 본인인증, 알림톡 발송 등 서비스 이행에 필수적인 업무를 외부 전문업체에 위탁하여 운영합니다.
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            제휴사 제공 (동의 시)
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            제약사, 도매상 등 파트너사와의 협업을 통해 맞춤형 의약품 정보나 혜택을 제공하기 위한 목적으로 이용자의 동의를 받아 개인정보를 제공할 수 있습니다.
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                            데이터 분석
                                        </Td>
                                        <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                            서비스 개선 및 마케팅 통계 작성을 위해 개인을 식별할 수 없는 형태로 가공된 비식별 정보를 제휴사 등에 제공할 수 있습니다.                             
                                        </Td>
                                    </Tr>
                                </Tbody>
                            </Table>
                        </VStack>

                        {/* 제 4조 [개인정보의 보유 및 이용 기간] */}

                        <VStack
                            justifyContent={"flex-start"}
                            alignItems={"flex-start"}
                            width={"100%"}
                        >

                            {/* 레이블 */}

                            <Text fontSize={16} fontWeight={700} color={colors.black}>
                                제 3조 [개인정보의 제3자 제공 및 위탁]
                            </Text>

                            {/* 내용 */}

                            <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                                회사는 회원 탈퇴 시까지 정보를 보유하며, 목적 달성 시 즉시 파기합니다.<br />
                                단, 관계 법령(통신비밀보호법 등) 및 부정이용 방지를 위해 필요한 경우<br />
                                내부 방침에 따라 일정 기간 보관할 수 있습니다.
                            </Text>
                        </VStack>

                        {/* 제 5조 [개인정보의 보호책임자] */}

                        <VStack
                            justifyContent={"flex-start"}
                            alignItems={"flex-start"}
                            width={"100%"}
                        >

                            {/* 레이블 */}

                            <Text fontSize={16} fontWeight={700} color={colors.black}>
                                제 5조 [개인정보의 보호책임자]
                            </Text>

                            {/* 내용 */}

                            <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                                ∙ 이름: 구자형<br />
                                ∙ 이메일: contact@pharm-chat.com<br />
                            </Text>
                        </VStack>

                    </VStack>
           
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}